<template>
  <!-- A moldura do app — cabeçalho e abas — não entra em tela que é a própria marca
       (boas-vindas): ali a tela inteira é o conteúdo. -->
  <AppBar v-if="withFrame" :links="links" :links-max="linksMax" :name="playerName" :level="level" />
  <router-view v-slot="{ Component }">
    <component :is="Component" />
  </router-view>
  <BottomNav v-if="withFrame" />

  <!-- Vão para o `body`: dentro de `#app` a regra de empilhamento das faixas reescreve o
       `position` e o diálogo vira um bloco no fim da página. -->
  <Teleport to="body">
  <!-- O aviso de desistência mora aqui, e não dentro da tela de jogo: qualquer porta que
       troque a partida — cartão de Hoje, folha de modos, nó da trilha, lista de duelos —
       passa pelo mesmo ponto na store, e o casco é quem pergunta. -->
  <div v-if="pendingSwitch" class="scrim" @click.self="cancelSwitch">
    <div class="confirm" role="dialog" aria-modal="true" aria-label="Trocar de partida">
      <h3>{{ switchTitle }}</h3>
      <p>Você está no meio de uma partida, e sair dela conta como desistir.</p>
      <p class="consequence">{{ consequence }}</p>
      <div class="actions">
        <button class="btn btn-outline" type="button" @click="cancelSwitch">continuar jogando</button>
        <button class="btn btn-cta" type="button" @click="confirm">desistir e trocar</button>
      </div>
    </div>
  </div>

  <!-- Duelo tem relógio correndo: sair da tela é desistir, mesmo indo para outra aba. -->
  <div v-if="pendingExit" class="scrim" @click.self="cancelExit">
    <div class="confirm" role="dialog" aria-modal="true" aria-label="Sair do duelo">
      <h3>Sair do duelo?</h3>
      <p>O relógio do duelo está correndo. Sair conta como jogado — e perde.</p>
      <p class="consequence">Não dá para voltar a esta partida depois.</p>
      <div class="actions">
        <button class="btn btn-outline" type="button" @click="cancelExit">voltar ao duelo</button>
        <button class="btn btn-cta" type="button" @click="signOut">sair e desistir</button>
      </div>
    </div>
  </div>
  </Teleport>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import AppBar from './components/AppBar.vue';
import BottomNav from './components/BottomNav.vue';

export default {
  name: 'App',
  components: { AppBar, BottomNav },
  computed: {
    ...mapState(['pendingSwitch', 'pendingExit']),
    ...mapGetters(['stats', 'trail', 'gamePhase', 'activeDuel', 'level', 'displayName', 'mustChangePassword']),
    /** Anônimo não tem apelido: o cabeçalho mostra o mesmo rótulo que a tela de Perfil. */
    playerName() {
      return this.displayName || 'Anônimo';
    },
    switchTitle() {
      return { phase: 'Jogar outra fase?', duel: 'Jogar o duelo?' }[this.pendingSwitch?.kind]
        || 'Trocar de modo?';
    },
    /** O preço muda com o modo em que se está, e é ele que a pessoa precisa ler. */
    consequence() {
      if (this.activeDuel) return 'No duelo, desistir conta como jogado — e perde.';
      if (this.gamePhase) return 'Na trilha, desistir gasta um elo, como perder a fase.';
      return 'A partida aberta é encerrada com o que já foi feito.';
    },
    /** Energia da trilha. Só aparece no cabeçalho quando a trilha já foi carregada. */
    links() {
      return this.trail ? this.trail.lives : 0;
    },
    linksMax() {
      return this.trail ? this.trail.rules.max_lives : 0;
    },
    withFrame() {
      return !this.$route.meta.standalone;
    },
  },
  methods: {
    ...mapActions(['confirmSwitch', 'cancelSwitch', 'confirmExit', 'cancelExit']),
    async confirm() {
      await this.confirmSwitch();
      if (this.$route.path !== '/') this.$router.push('/');
    },
    async signOut() {
      const rota = await this.confirmExit();
      if (rota) this.$router.push(rota);
    },
  },
  async created() {
    // Aqui e não no GameView: quem abre /perfil ou /ranking direto — por link ou por
    // refresh — precisa do jogador resolvido do mesmo jeito.
    await this.$store.dispatch('init');
  },
  watch: {
    // O guarda do router não vê a primeira carga: `/me` responde depois da rota de entrada.
    mustChangePassword(value) {
      if (!value || ['password', 'password-reset'].includes(this.$route.name)) return;
      this.$router.replace({ name: 'password' });
    },
    '$route.name': {
      immediate: true,
      handler(name) {
        document.getElementById('app')?.setAttribute('data-screen', name || 'today');
      },
    },
  },
};
</script>
